import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const API_BASE_URL = "https://emailtool-backend-dev.protoneffect.net";
const adminEmails = ["tariq.qadri@protoneffect.com"];

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log("API Response:", data); // Debug API response

      if (response.ok) {
        const userEmail = data?.user?.email; // Extract email from response
        console.log("User Email:", userEmail); // Debug email received

        if (adminEmails.includes(userEmail)) {
          localStorage.setItem("adminToken", data.token);
          localStorage.setItem("role", "admin");
          localStorage.setItem("adminEmail", userEmail); // Store admin email

          console.log("Redirecting to /admin...");
          navigate("/admin");
        } else {
          setError("Access Denied: You are not an admin.");
        }
      } else {
        setError(data.error || "Invalid credentials");
      }
    } catch (error) {
      console.error("Login Error:", error);
      setError("Something went wrong. Try again.");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <div className="card" style={{ maxHeight: "500px" }}>
        <h2 className="text-center">Admin Login</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="mb-3">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="btn btn-primary w-100" onClick={handleLogin}>
          Login
        </button>
        <div style={{ textAlign: "center", width: "100%", marginTop: "20px" }}>
          <Link to="/"> Login as User</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
